module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-plus-36199ca253db8a58cf7e9bd19d10232a.svg";